<template>

    <!-- copy from here -->

    <div class="competence-main">
        <div class="container-fluid p-0">
            <div class="row justify-content-center d-none d-md-block">

                <table style="width:100%" class="main-nav-table">
                    <tr>
                        <td v-if="hideoverview == false" class="large-button-container">
                            <div class="p-1 large-button rounded orange" v-bind:class="{'selected':step == 1}" @click="step = 1">
                                Översikt
                            </div>
                        </td>
                        <td v-if="hideworkorganisation == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hideworkorganisation == false" class="large-button-container">
                            <div class="p-1 large-button rounded orange" v-bind:class="{'selected':step == 2}" @click="step = 2">
                                Arbets-<br />organisation
                            </div>
                        </td>
                        <td v-if="hideemployees == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hideemployees == false" class="large-button-container">
                            <div class="p-1 large-button rounded orange" v-bind:class="{'selected':step == 3}" @click="step = 3">
                                Anställda
                            </div>
                        </td>
                        <td v-if="hiderules == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hiderules == false" class="large-button-container">
                            <div class="p-1 large-button rounded orange" v-bind:class="{'selected':step == 4}" @click="step = 4">
                                Regelverk
                            </div>
                        </td>
                        <td v-if="hiderevision == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hiderevision == false" class="large-button-container">
                            <div class="p-1 large-button rounded orange" v-bind:class="{'selected':step == 5}" @click="step = 5">
                                Revision
                            </div>
                        </td>
                        <td v-if="hidedevelopmentplan == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hidedevelopmentplan == false" class="large-button-container">
                            <div class="p-1 large-button rounded orange" v-bind:class="{'selected':step == 6}" @click="step = 6">
                                Utvecklingsplan
                            </div>
                        </td>
                        <td v-if="hidecompetencematrix == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hidecompetencematrix == false" class="large-button-container">
                            <div class="p-1 large-button rounded orange" v-bind:class="{'selected':step == 7}" @click="step = 7">
                                Kompetensmatris
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="row justify-content-center mt-3">
                <div v-if="hideoverview == false" class="p-0 d-block d-md-none col-12">
                    <div class="orange my-1 mobile-button rounded" v-bind:class="{'selected':step == 1}" @click="step = 1">
                        <span v-html="'Översikt'"></span>
                    </div>
                </div>
                <div v-if="step == 1" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">
                            <v-expansion-panel eager class='theme-orange'
                                data-manual-info-block="competence-step1-att-utveckla-kompetensen"
                                data-manual-info-scope="Scenario"
                                data-manual-module="CompetenceDevelopment"
                                data-manual-overview-section="CompetenceDevelopment"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="competence,overview,intro">
                                <v-expansion-panel-title color="orange" data-manual-info-title>
                                    Att utveckla kompetensen
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        För att utveckla kompetensen hos industriarbetarna och utveckla effektiva företag krävs att lokala parter gemensamt utvecklar arbetsorganisationen. I det arbetet ligger att definiera arbetsuppgifter i alla befattningar och utvecklingsblock. Först då blir det tydligt vilka arbetsuppgifter personer kan och bör lära sig.
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green' eager>
                                                <v-expansion-panel-title color="green">
                                                    Stöd i avtal
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        I våra avtal finns skrivningar om hur arbetsgivaren ska leva upp till sitt ansvar för kompetensutvecklingsfrågorna. <br><br>
                                                        Dessa skrivningar är tydliga om att kompetensutvecklingen ska utgå ifrån inte bara företagets utan också den enskilda arbetstagarens perspektiv. Här anges också att parterna ska samverka och hur arbetet kan läggas upp (utvecklingssamtal, utvecklingsplaner med mera).<br><br>
                                                        Stöd finns också i utvecklings- och jämställdhetsavtal.
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green' eager>
                                                <v-expansion-panel-title color="green">
                                                    Samarbete med arbetsgivaren
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Arbetet med kompetensutvecklingen på företaget förutsätter en nära samverkan med företagsledningen. Det är arbetsgivaren som är ansvarig för kompetensutvecklingen på företaget – det är också denna som sitter på besluten om resurser. Det gäller både de ekonomiska resurserna och de anställdas tid.<br><br>
                                                        Trots avtalstexterna om kompetensutveckling, så fungerar det inte som det ska överallt. På många företag är både personalutbildningen och lärandet i arbetet på en för låg nivå.<br><br>
                                                        Nedan förs resonemang om några vanliga hinder och hur klubben kan hantera dessa.
                                                    </div>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Otydlig bild av företagets framtida utveckling
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    Det är viktigt att klubben har en bild av hur en effektiv arbetsorganisation ser ut sett både utifrån industriarbetarnas och företagets perspektiv. Det är en förutsättning för att kunna arbeta på ett bra sätt med kompetensutvecklingen på företaget.<br><br>
                                                                    IF Metall har tagit fram material som stöd för arbetet med kompetensutveckling. Några är:<br><br>
                                                                    •	Hållbart arbete: Metoder för utveckling. Där beskrivs olika sätt att arbeta fram en partsgemensam bild av företagets framtida utveckling.<br>
                                                                    •	Hållbart arbete – Kompetensutveckling.<br>
                                                                    •	Första steget i din kompetensutveckling.<br>
                                                                    Materialen finns på IF Metalls medlemsportal, www.ifmetall.se under rubriken Arbetsutveckling.
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Ser inte nyttan
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    Många gånger kan det vara svårt att i siffror visa att kompetensutveckling lönar sig. Det finns dock forskning på området. En studie  av tidsanvändningen i ett tillverkningssystem visade exempelvis att drygt en tredjedel av maskintiden gick bort i form av stoppförluster och ytterligare tid försvann på grund av hastighetsförluster, kassation, justeringar med mera. Forskarna konstaterade att arbetare som kan, får och vill kan mer än halvera dessa förluster. Genom att utveckla de anställdas kompetens och ge dem befogenhet att hantera de problem som uppstår kan företaget förbättra sin lönsamhet betydligt. <br><br>
                                                                    Att satsa på kompetensutveckling måste ses som en investering och inte bara en kostnad. Investerar ett företag exempelvis 100 miljoner kronor i ny teknik, så måste man också göra rejäla satsningar på kompetensutveckling för att investeringen ska ge önskad utdelning. <br><br>
                                                                    Det är också viktigt att se sambandet mellan ISO-certifiering och kompetensutveckling. För att bli ISO-certifierad krävs att kompetensutvecklingen fungerar på företaget.
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Om ekonomin är ett hinder
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    Om ekonomin är ett hinder finns det flera vägar att gå.<br><br>
                                                                    En är att arbeta med mer kostnadseffektiva utvecklingsformer. I stället för att skicka iväg anställda på dyra externa utbildningar går det kanske att anordna motsvarande utbildning på arbetsplatsen. Man tar utbildaren till deltagarna i stället för deltagarna till utbildaren. Kanske finns också intern sakkunskap som kan användas i utbildningen. Detta kan ge möjlighet för fler att delta. Det gör det också möjligt att anpassa upplägget efter produktionens krav, både ifråga om innehåll och förläggning i tid. <br><br>
                                                                    Det gäller också att vara tydlig om att all utveckling inte handlar om kurser. Att delta i utvecklingsprojekt, göra studiebesök eller pröva andra arbetsuppgifter behöver inte vara särskilt kostsamt.<br><br>
                                                                    En annan – eller kompletterande – väg kan vara att påbörja en diskussion om att starta kompetensutvecklingsprojekt med stöd av europeiska socialfonden (ESF).<br><br>
                                                                    På ESF:s hemsida (www.esf.se) finns mer information, bland annat om regionala ansökningsdatum och vilket stöd som finns för att göra en ansökan. Vissa av förbundets avdelningar har erfarenhet av ansökningar till socialfonden och kan också vara behjälpliga.
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Brist på kunskap om utbildningssamordnare
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    Ibland är hindret för kompetensutveckling att företaget inte hittar lämpliga utbildningar. <br><br>
                                                                    Skolverket, eventuella branschorganisationer, teknikcollege, universitet i regionen och avdelningen är exempel på organisationer som det kan vara värt att ta kontakt med. Klubben kan också lyssna med -klubben på något liknande företag. Kanske har den tips att ge.
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Det finns ingen ansvarig
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    Många gånger beror bristande kompetensutveckling på att det inte finns någon på företaget som har ett tydligt uppdrag att arbeta med frågan. <br><br>
                                                                    För att satsningar på kompetensutveckling ska ge ett önskvärt resultat krävs systematik, resurser och långsiktighet.
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel eager class='theme-orange'
                                data-manual-info-block="competence-step1-arbetsgangen"
                                data-manual-info-scope="Scenario"
                                data-manual-module="CompetenceDevelopment"
                                data-manual-overview-section="CompetenceDevelopment"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="competence,overview,flow">
                                <v-expansion-panel-title color="orange" data-manual-info-title>
                                    Arbetsgången
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        Att utveckla kompetensen i företaget kräver systematiskt och långsiktigt arbete. Arbetet kan delas in i nedanstående delar.
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Arbetsorganisation
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Grunden är en utvecklande arbetsorganisation. I det arbetet måste befattningar och utvecklingsblock definieras. I verktyget Hållbart arbete görs detta arbete i den blå rutan Arbetsorganisation.
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Skriva in anställda, koppla till befattning
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        När lokala parter kommit överens om en lämplig arbetsorganisation blir nästa steg att koppla de anställda till den befattning där de utför sitt huvudsakliga arbete.
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Regelverk
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Lokala parter bör exempelvis reglera kartläggning av alla personers kompetens, möjligheterna till kompetensutveckling och en årlig individuell utvecklingsplan.
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Inventera vilka arbetsuppgifter en individ kan och utför
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Det är vanligt att kompetensmatriser används för att synliggöra kompetensen inom
                                                        grupper och vilken kompetensutveckling som är planerad att genomföras.
                                                        Kompetensmatriser genereras som en rapport i verktyget Hållbart arbete.
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Individuell utvecklingsplan
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Alla anställda ska ha en individuell utvecklingsplan. Verktyget Hållbart arbete underlättar det arbetet.
                                                    </div>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Säkerställ att kunskaperna får användas
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    Det finns många goda planer som aldrig har gett resultat. Det är därför viktigt att det i planeringen anges vem/vilka som har ansvar för att de olika insatserna genomförs. Det är också viktigt att det finns avsatt ekonomiska resurser och tid. Produktionen måste planeras så att den anställda kan lämna sina dagliga arbetsuppgifter för att delta i kompetensutvecklingen.
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Säkra jämställd utveckling
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    I arbetet med att kartlägga kompetens och önskad utveckling gäller det också att säkra att insatserna bidrar till en ökad jämställdhet på företaget. Att de stödjer arbetet med att nå IF Metalls jämställdhetsmål:<br>
                                                                    •	Kvinnor och män ska få utbildning och utveckling i arbetet i samma omfattning.<br>
                                                                    •	Kvinnor och män ska kunna arbeta ett helt arbetsliv utan att ta skada vare sig till kropp eller själ.<br>
                                                                    •	Kvinnor och män ska ha trygghet i anställningen och stöd i omställningen.<br>
                                                                    •	Kvinnor och män ska ha likvärdig lön och löneutveckling.<br>
                                                                    •	Kvinnor och män ska dela på ansvaret för hem och familj. <br>
                                                                    •	Kvinnor och män ska ha samma inflytande i det fackliga arbetet<br>
                                                                    – på arbetsplatsen, i avdelningen och i förbundet. <br><br>
                                                                    Det handlar om att i kartläggningen tydliggöra både mäns och kvinnors kompetens. Det handlar också om att se till att både kvinnor och män tar del av de utvecklingsinsatser som planeras. Kompetensutvecklingsarbetet är strategiskt för att uppnå jämställda löner.
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel eager class='theme-orange'
                                data-manual-info-block="competence-step1-kompetensmatris"
                                data-manual-info-scope="Scenario"
                                data-manual-module="CompetenceDevelopment"
                                data-manual-overview-section="CompetenceDevelopment"
                                data-manual-complexity="Enkel"
                                data-manual-info-tags="competence,overview,matrix">
                                <v-expansion-panel-title color="orange" data-manual-info-title>
                                    Kompetensmatris
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        Det är vanligt att kompetensmatriser används för att synliggöra kompetensen inom grupper och vilken kompetensutveckling som är planerad att genomföras. Kompetensmatriser genereras som en rapport i verktyget Hållbart arbete.
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>
                <div v-if="hideworkorganisation == false" class="p-0 d-block d-md-none col-12">
                    <div class="orange my-1 mobile-button rounded" v-bind:class="{'selected':step == 2}" @click="step = 2">
                        <span v-html="'Arbetsorganisation'"></span>
                    </div>
                </div>
                <div v-if="step == 2" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">
                            <v-expansion-panel eager class='theme-orange'
                                data-manual-info-block="competence-step2-arbetsorganisation"
                                data-manual-info-scope="Scenario"
                                data-manual-module="CompetenceDevelopment"
                                data-manual-overview-section="CompetenceDevelopment"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="competence,workorganisation,intro">
                                <v-expansion-panel-title color="orange" data-manual-info-title>
                                    Arbetsorganisation
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        Grunden för kompetensutveckling är en utvecklande arbetsorganisation. I det arbetet måste befattningar och utvecklingsblock definieras. <br><br>
                                        Kort innebär arbetet:<br>
                                        -	definiera befattningar<br>
                                        -	beskriva arbetsinnehållet i olika befattningar<br>
                                        -	skapa/sätta namn på olika utvecklingsblock<br>
                                        -	sortera in arbetsuppgifter i de olika utvecklingsblocken.<br><br>
                                        När detta arbete är gjort finns det en arbetsbeskrivning med tydliga utvecklingsblock för alla befattningar. För ytterligare fördjupning se område Arbetsorganisation.<br><br>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-orange'>
                                <v-expansion-panel-title color="orange">
                                    VERKTYGET – ARBETSORGANISATIONEN
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">

                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Definiera befattningar
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">

                                                    </div>
                                                    <div class="mt-5">
                                                        <manage-workpositions v-bind:disabled="writeworkorganisation == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected" @job-positions-changed="jobPositionsChanged"></manage-workpositions>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Arbetsinnehåll och utveckling
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">

                                                    </div>
                                                    <div class="mt-5">
                                                        <work-content-and-development v-bind:disabled="writeworkorganisation == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></work-content-and-development>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Utvecklingsblock
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">

                                                    </div>
                                                    <div class="mt-5">
                                                        <manage-developmentblocks v-bind:disabled="writeworkorganisation == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></manage-developmentblocks>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Fördela arbetsuppgifter
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">

                                                    </div>
                                                    <div class="mt-5">
                                                        <manage-worktasks v-bind:disabled="writeworkorganisation == false" v-bind:model='model'  v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></manage-worktasks>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>

                <div v-if="hideemployees == false" class="p-0 d-block d-md-none col-12">
                    <div class="orange my-1 mobile-button rounded" v-bind:class="{'selected':step == 3}" @click="step = 3">
                        <span v-html="'Anställda'"></span>
                    </div>
                </div>
                <div v-if="step == 3" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">
                            <v-expansion-panel eager class='theme-orange'
                                data-manual-info-block="competence-step3-att-skriva-in-anstallda"
                                data-manual-info-scope="Scenario"
                                data-manual-module="CompetenceDevelopment"
                                data-manual-overview-section="CompetenceDevelopment"
                                data-manual-complexity="Enkel"
                                data-manual-info-tags="competence,employees,intro">
                                <v-expansion-panel-title color="orange" data-manual-info-title>
                                    Att skriva in anställda
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        När innehållet och utvecklingsmöjligheterna i befattningarna är beskrivna är det dags att skriva in de anställda på företaget om detta inte är gjort tidigare. <br><br>
                                        Det är möjligt att skriva in anställda på flera ställen i verktyget.<br><br>
                                        <ul>
                                            <li>Lönesättning, steg Inplacering av individer.</li>
                                            <li>Kompetensutveckling, steg Anställda.</li>
                                            <li>Jämställdhet, steg Könsfördelning.</li>
                                        </ul>
                                        Oavsett var inmatning av anställda sker är uppgifterna desamma.
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-orange'>
                                <v-expansion-panel-title color="orange">
                                    VERKTYGET – SKRIV IN ANSTÄLLDA
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">
                                        Obligatoriska uppgifter att lägga in ur ett kompetensutvecklingsperspektiv är anställningsnummer, namn och befattning.<br><br>
                                        Yrkets startdatum beräknas utifrån personers tidigare erfarenhet. Har en anställd exempelvis två års erfarenhet<br>
                                        som hon/han kan tillgodoräkna sig klickar eller fyller du i datum två år tillbaka i tiden. Om anställningsdatum är <br>
                                        2010-01-01 blir Yrkets startdatum 2008-01-01.<br><br>
                                        I verktyget finns en funktion under Administration i menyraden som du kan använda för att automatiskt lägga upp de anställda.<br>Funktionen heter Importera anställda.<br><br>
                                    </div>

                                    <div class="mt-5">
                                        <wage-employee-admin v-bind:disabled="writeemployees == false" v-bind:model="internalModel" v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-employee-admin>
                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-orange'>
                                <v-expansion-panel-title color="orange">
                                    VERKTYGET - UTBILDNINGSREGISTER
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">

                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Utbildningsregister
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">

                                                    </div>
                                                    <div class="mt-5">
                                                        <competence-register v-bind:disabled="writeemployees == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></competence-register>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Individens utbildning
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">

                                                    </div>
                                                    <div class="mt-5">
                                                        <competence-individual v-bind:disabled="writeemployees == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></competence-individual>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>

                <div v-if="hiderules == false" class="p-0 d-block d-md-none col-12">
                    <div class="orange my-1 mobile-button rounded" v-bind:class="{'selected':step == 4}" @click="step = 4">
                        <span v-html="'Regelverk'"></span>
                    </div>
                </div>
                <div v-if="step == 4" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">
                            <v-expansion-panel eager class='theme-orange'
                                data-manual-info-block="competence-step4-regler-uppflyttning"
                                data-manual-info-scope="Scenario"
                                data-manual-module="CompetenceDevelopment"
                                data-manual-overview-section="CompetenceDevelopment"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="competence,rules,competence-matrix">
                                <v-expansion-panel-title color="orange" data-manual-info-title>
                                    Regler för uppflyttning i kompetensmatrisen
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        Det bör finnas tydliga regler för hur besluts fattas avseende när en person är godkänd i ett utvecklingsblock.<br><br>
                                        Här finns olika alternativ. Några exempel är:<br>
                                        <ul>
                                            <li>Normal upplärningstid för utvecklingsblocket. (Med normal upplärningstid avses den tid det i ett normalfall tar för en person att lära utvecklingsblocket till rätt kvalitet och kvantitet)</li>
                                            <li>Olika typer av prov</li>
                                            <li>Förslag från produktionsledare, fack, anställd</li>
                                        </ul>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-orange'>
                                <v-expansion-panel-title color="orange">
                                    VERKTYGET – LOKALT REGELVERK
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">

                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">
                                        <common-rule v-bind:disabled="writerules == false" regulationtype="0" v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></common-rule>
                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>

                <div v-if="hiderevision == false" class="p-0 d-block d-md-none col-12">
                    <div class="orange my-1 mobile-button rounded" v-bind:class="{'selected':step == 5}" @click="step = 5">
                        <span v-html="'Revision'"></span>
                    </div>
                </div>
                <div v-if="step == 5" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">
                            <v-expansion-panel class='theme-orange'>
                                <v-expansion-panel-title color="orange">
                                    Revision av anställda
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">

                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-orange'>
                                <v-expansion-panel-title color="orange">
                                    VERKTYGET – REVISION
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">

                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel eager class='theme-green'
                                                data-manual-info-block="competence-step5-revision-inom-befattning"
                                                data-manual-info-scope="Scenario"
                                                data-manual-module="CompetenceDevelopment"
                                                data-manual-overview-section="CompetenceDevelopment"
                                                data-manual-complexity="Mellan"
                                                data-manual-info-tags="competence,revision,position">
                                                <v-expansion-panel-title color="green" data-manual-info-title>
                                                    Revision av kompetens inom befattning
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2" data-manual-info-body>
                                                        <p>
                                                            Din arbetsuppgift är att:
                                                        </p><ol>
                                                            <li>Välja befattning.</li>
                                                            <li>Välja anställd.</li>
                                                            <li>
                                                                Kryssa för något av följande alternativ:<br>
                                                                - Godkänd (personen kan och utför arbetsuppgifterna självständigt. Grund är alltid för ikryssat).<br>
                                                                - Nästa steg (personen har en planerad utveckling för blocket).<br>
                                                                - Utveckling (anger den möjliga utvecklingen för individen).<br>
                                                                Samtliga tre, Godkänt - Nästa steg - Utveckling, påverkar lönestatistiken.
                                                            </li>
                                                            <li>Klicka Spara kompetens.</li>
                                                        </ol><p></p>

                                                        <br /><br />
                                                    </div>
                                                    <div class="mt-5">
                                                        <wage-employee-competences v-bind:disabled="writerevision == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-employee-competences>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel eager class='theme-green'
                                                data-manual-info-block="competence-step5-revision-mangkunnighet"
                                                data-manual-info-scope="Scenario"
                                                data-manual-module="CompetenceDevelopment"
                                                data-manual-overview-section="CompetenceDevelopment"
                                                data-manual-complexity="Mellan"
                                                data-manual-info-tags="competence,revision,mangkunnighet">
                                                <v-expansion-panel-title color="green" data-manual-info-title>
                                                    Revision av kompetens utanför befattning - mångkunnighet
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2" data-manual-info-body>
                                                        <p>
                                                            Din arbetsuppgift är att:
                                                        </p><ol>
                                                            <li>Välja befattning.</li>
                                                            <li>Välja anställd.</li>
                                                            <li>Välja befattning för mångkunnighet.</li>
                                                            <li>Kryssa för Godkänd på de block personen kan utföra arbetsuppgifter utanför egen befattning.</li>
                                                            <li>Klicka Spara mångkunnighet.</li>
                                                        </ol>
                                                    </div>
                                                    <div class="mt-5">
                                                        <competence-employee-multiskill v-bind:disabled="writerevision == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></competence-employee-multiskill>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>

                <div v-if="hidedevelopmentplan == false" class="p-0 d-block d-md-none col-12">
                    <div class="orange my-1 mobile-button rounded" v-bind:class="{'selected':step == 6}" @click="step = 6">
                        <span v-html="'Utvecklingsplan'"></span>
                    </div>
                </div>
                <div v-if="step == 6" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">
                            <v-expansion-panel eager class='theme-orange'
                                data-manual-info-block="competence-step6-individens-utvecklingsplan"
                                data-manual-info-scope="Scenario"
                                data-manual-module="CompetenceDevelopment"
                                data-manual-overview-section="CompetenceDevelopment"
                                data-manual-complexity="Enkel"
                                data-manual-info-tags="competence,development-plan,intro">
                                <v-expansion-panel-title color="orange" data-manual-info-title>
                                    Individens utvecklingsplan
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        Verktyget skapar automatiskt en utvecklingsplan utifrån den information som klickats in i verktyget i steget revision av individens kompetens.
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-orange'>
                                <v-expansion-panel-title color="orange">
                                    VERKTYGET – INDIVIDENS UTVECKLINGSPLAN
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">

                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">
                                        <competence-developmentplan v-bind:disabled="writedevelopmentplan == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></competence-developmentplan>
                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>

                <div v-if="hidecompetencematrix == false" class="p-0 d-block d-md-none col-12">
                    <div class="orange my-1 mobile-button rounded" v-bind:class="{'selected':step == 7}" @click="step = 7">
                        <span v-html="'Kompetensmatris'"></span>
                    </div>
                </div>
                <div v-if="step == 7" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">
                            <v-expansion-panel eager class='theme-orange'
                                data-manual-info-block="competence-step7-kompetensmatris-intro"
                                data-manual-info-scope="Scenario"
                                data-manual-module="CompetenceDevelopment"
                                data-manual-overview-section="CompetenceDevelopment"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="competence,matrix,intro">
                                <v-expansion-panel-title color="orange" data-manual-info-title>
                                    Kompetensmatris
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded" data-manual-info-body>
                                    <div class="pt-2 pb-4 col-md-7">
                                        Här redovisas gruppernas totala kompetens.<br><br>
                                        Genom att överföra kompetensmatrisen till Excel kan ytterligare lokala bearbetningar göras. Det kan exempelvis vara att synliggöra kompetensgapet i befattningen.<br><br>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel eager class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Exempel – kompetensmatris som planeringsinstrument
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <img src="/images/IFMetall/Exempel_kompetensmatris.PNG" alt="Exempel – kompetensmatris som planeringsinstrument">
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-orange'>
                                <v-expansion-panel-title color="orange">
                                    VERKTYGET - MATRISER
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">

                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Kompetensmatris
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">

                                                    </div>
                                                    <div class="mt-5">
                                                        <wage-employee-competence-matrix v-bind:disabled="writecompetencematrix == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-employee-competence-matrix>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Mångkunnighetsmatris
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">

                                                    </div>
                                                    <div class="mt-5">
                                                        <competence-matrix-multiskills v-bind:disabled="writecompetencematrix == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></competence-matrix-multiskills>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Utbildningsmatris
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">

                                                    </div>
                                                    <div class="mt-5">
                                                        <competence-matrix-education v-bind:disabled="writecompetencematrix == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></competence-matrix-education>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- to here -->
</template>


<script>


    import ManageWorkpositions from '../workorganisation/manage-workpositions.vue'
    import ManageWorktasks from '../workorganisation/manage-worktasks.vue'
    import WorkContentAndDevelopment from '../workorganisation/work-content-and-development.vue'
    import ManageDevelopmentblocks from '../workorganisation/manage-developmentblocks.vue'
    import WageEmployeeAdmin from '../wagesetting/wage-employee-admin.vue'
    import CommonRule from '../../common/common-rule.vue'
    import WageEmployeeCompetenceMatrix from '../wagesetting/wage-employee-competence-matrix.vue'
    import WageEmployeeCompetences from '../wagesetting/wage-employee-competences.vue'

    import CompetenceEmployeeMultiskill from './competence-employee-multiskill.vue'
    import CompetenceIndividual from './competence-individual.vue'
    import CompetenceRegister from './competence-register.vue'
    import CompetenceDevelopmentplan from './competence-developmentplan.vue'
    import CompetenceMatrixMultiskills from './competence-matrix-multiskills.vue'
    import CompetenceMatrixEducation from './competence-matrix-education.vue'
        
    export default {

        name: 'competence-main',
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
            hideoverview: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeoverview: {
                type: Boolean,
                required: false,
                default: false,
            },
            hideworkorganisation: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeworkorganisation: {
                type: Boolean,
                required: false,
                default: false,
            },
            hideemployees: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeemployees: {
                type: Boolean,
                required: false,
                default: false,
            },
            hiderules: {
                type: Boolean,
                required: false,
                default: false,
            },
            writerules: {
                type: Boolean,
                required: false,
                default: false,
            },
            hiderevision: {
                type: Boolean,
                required: false,
                default: false,
            },
            writerevision: {
                type: Boolean,
                required: false,
                default: false,
            },
            hidedevelopmentplan: {
                type: Boolean,
                required: false,
                default: false,
            },
            writedevelopmentplan: {
                type: Boolean,
                required: false,
                default: false,
            },
            hidecompetencematrix: {
                type: Boolean,
                required: false,
                default: false,
            },
            writecompetencematrix: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            ManageWorkpositions,
            ManageWorktasks,
            WorkContentAndDevelopment,
            ManageDevelopmentblocks,
            WageEmployeeAdmin,
            CommonRule,
            WageEmployeeCompetenceMatrix,
            WageEmployeeCompetences,
            CompetenceEmployeeMultiskill,
            CompetenceRegister,
            CompetenceDevelopmentplan,
            CompetenceMatrixMultiskills,
            CompetenceMatrixEducation,
            CompetenceIndividual,
            
        },
        methods: {
            positionSelected(newVal) {
                this.selectedJobPosition = newVal;
            },
            jobPositionsChanged(jobPositions) {
                if (!Array.isArray(jobPositions)) {
                    return;
                }

                this.internalModel.JobPositions = jobPositions;

                var highestId = null;
                for (var i = 0; i < jobPositions.length; i++) {
                    var id = jobPositions[i] && (jobPositions[i].JobPositionId || jobPositions[i].jobPositionId);
                    id = Number(id);
                    if (id > 0 && (highestId === null || id > highestId)) {
                        highestId = id;
                    }
                }

                if (highestId !== null) {
                    this.selectedJobPosition = highestId;
                }
            }
        },

        data() {
            return {
                step: 1,
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                newWindow: {},
                selectedJobPosition: null,
            };
        },
        watch: {
            //selectedPosition1: function(newVal){
            //    this.getWorkTasks(newVal);
            //    this.getWorkBlocks(newVal);
            //},

        },
        mounted() {
            this.internalModel = this.model;
            /*
            alert("hideoverview:" + this.hideoverview);
            alert("writeoverview:" + this.writeoverview);
            alert("hideworkorganisation:" + this.hideworkorganisation);
            alert("writeworkorganisation:" + this.writeworkorganisation);
            alert("hideemployees:" + this.hideemployees);
            alert("writeemployees:" + this.writeemployees);
            alert("hiderules:" + this.hiderules);
            alert("writerules:" + this.writerules);
            alert("hiderevision:" + this.hiderevision);
            alert("writerevision:" + this.writerevision);
            alert("hidedevelopmentplan:" + this.hidedevelopmentplan);
            alert("writedevelopmentplan:" + this.writedevelopmentplan);
            alert("hidecompetencematrix:" + this.hidecompetencematrix);
            alert("writecompetencematrix:" + this.writecompetencematrix);
            */

        },
        setup () {
            //const workDialog = ref()
            //return { workDialog }
            return {};
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .large-button {
        text-align: center;
        display: grid;
        align-items: center;
        /*width:80px;*/
        min-height: 90px;
        background-color: blue;
        color: white !important;
        cursor: pointer;
        font-size: 15px;
    }

    .input {
        border: none;
        border-bottom: 1px solid #ccc;
    }

    td {
        word-wrap: break-word;
        word-break: break-all;
    }

    .drop {
        color: black;
        text-decoration: none;
        font-size: 20px;
    }

    .top-expanded {
    }

    .theme-purple .v-expansion-panel-title {
        background-color: #845893 !important;
        color: white !important;
    }

    .theme-purple .v-expansion-panel-text {
        background-color: #fbedff !important;
    }


    .theme-green .v-expansion-panel-title {
        background-color: #62B965 !important;
        color: white !important;
    }

    .theme-green .v-expansion-panel-text {
        background-color: #F1F1F1 !important;
    }

    .theme-orange .v-expansion-panel-title {
        background-color: #e79925 !important;
        color: white !important;
    }

    .theme-orange .v-expansion-panel-text {
        background-color: #fff7eb !important;
    }
</style>
